import { TFunction } from 'i18next'

import { IOption } from 'components/ui/select'
import { SaveMode } from 'components/layout/editableTable/editableTableRow'

export default (t: TFunction) =>
  [
    {
      value: SaveMode.Calculation.toString(),
      label: t('thisCalculationSheet'),
    },
    {
      value: SaveMode.Project.toString(),
      label: t('thisProject'),
    },
  ] as IOption[]
